import { useState } from "react";
import { ChatMessage, Citation, ToolMessageContent } from "../../api/models";
import { TOOL } from "./types";

export const useCitationIntentPanel = () => {
  const [activeCitation, setActiveCitation] =
    useState<
      [
        content: string,
        id: string,
        title: string,
        filepath: string,
        url: string,
        metadata: string,
      ]
    >();
  const [isCitationPanelOpen, setIsCitationPanelOpen] =
    useState<boolean>(false);
  const [isIntentPanelOpen, setIsIntentPanelOpen] = useState(false);
  const [activeIntent, setActiveIntent] = useState<string>("");
  const [currentIntentContent, setCurrentIntentContent] = useState<string>("");

  const onShowCitation = async (citation: Citation) => {
    if(citation.url?.includes("[/documents/")){
      const fileToOpen = citation.title;
      if (!fileToOpen) return;
      const response = await fetch(
        `/api/get_file?file_name=${encodeURIComponent(fileToOpen)}`,
      );
      if (response.ok) {
        const blobURL = await response.json().then((data) => data.file_url);
        // Open the file URL in a new tab
        window.open(blobURL, "_blank");
      } else {
        console.error("Failed to view file");
      }
    }
    else{
      let url = citation.url?.split("](")[1];
      url = url?.slice(0,-1);
      window.open(url);
  }
  };

  const onShowIntent = (intent: string) => {
    setActiveIntent(intent);
    setIsIntentPanelOpen(true);
    setIsCitationPanelOpen(false);
  };

  const parseCitationFromMessage = (message: ChatMessage) => {
    if (message.role === TOOL) {
      try {
        const toolMessage = JSON.parse(message.content) as ToolMessageContent;
        return { citations: toolMessage.citations, intent: toolMessage.intent };
      } catch {
        return { citations: [], intent: "" };
      }
    }
    return { citations: [], intent: "" };
  };

  return {
    activeCitation,
    activeIntent,
    currentIntentContent,
    isCitationPanelOpen,
    isIntentPanelOpen,
    setActiveCitation,
    setCurrentIntentContent,
    setIsCitationPanelOpen,
    setIsIntentPanelOpen,
    onShowCitation,
    onShowIntent,
    parseCitationFromMessage,
  };
};
